// script for m5 + mtw5 together

document.addEventListener('DOMContentLoaded', function () {

    const videos = document.querySelectorAll(
        '.mtw5-exp-page video:has(source[data-hevc])'
    );

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Detect Apple devices
    const isIOS =
        /iPad|iPhone|iPod/.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    const isMacOS = /Macintosh/.test(userAgent);

    videos.forEach(function (video) {
        const source = video.querySelector('source');

        if (!source) return;

        // Apple devices → HEVC MP4
        if (isIOS || isMacOS) {
            source.src = source.dataset.hevc;
            source.type = 'video/mp4';
        }
        // Windows / Android / other devices → WebM
        else {
            source.src = source.dataset.webm;
            source.type = 'video/webm';
        }

        video.load();
    });

    function updateSoundRevelationBg() {
        const soundSection = document.querySelector(
            '.sound-revelation-section'
        );

        if (!soundSection) return;

        if (isIOS || isMacOS) {
            soundSection.classList.add('remove-bg');
        } else {
            soundSection.classList.remove('remove-bg');
        }
    }

    updateSoundRevelationBg();
    window.addEventListener('resize', updateSoundRevelationBg);


    const floatBtn = document.querySelector('.floating-btn-wrap');
    const srvSection = document.querySelector('.sound-revelation-section');

    if (floatBtn && srvSection) {

        const srvObserver = new IntersectionObserver(function (entries) {
            const isVisible = entries[0].isIntersecting;

            if (isVisible) {
                floatBtn.classList.remove('active');
            } else if (window.scrollY > 500) {
                floatBtn.classList.add('active');
            } else {
                floatBtn.classList.remove('active');
            }
        }, {
            threshold: 0
        });

        srvObserver.observe(srvSection);
    }



    const $mtw5Page = $('.mtw5-exp-page');

    if (!$mtw5Page.length) return;

    const $body = $('body');
    const $header = $('.header .header__row');
    const $nav = $('.navigations-wrapper');
    const $productBar = $('.product-pagebar-wrapper.pdp-top-sticky-bar');
    const $announcementBar = $('.announcement-bar:not(.is-hidden)');
    const $stickyBar = $('.announcement-bar.sticky-bar:not(.is-hidden)');

    if (!$productBar.length) return;

    function updateMTW5Header() {

        const scrollTop = $(window).scrollTop();
        const isDesktop = window.innerWidth >= 1024;
        const spacing = isDesktop ? 24 : 16;

        const announcementHeight = $announcementBar.length
            ? $announcementBar.innerHeight()
            : 0;

        const isSticky = $stickyBar.length > 0;

        const productBarHeight = $productBar.innerHeight();


        if (scrollTop > 0) {
            $body.addClass('m5-discover-active');
        } else {
            $body.removeClass('m5-discover-active');
        }


        $productBar.css({
            transform: 'none',
            top: isSticky
                ? announcementHeight + 'px'
                : '0px'
        });


        let headerTop = 0;

        if (isSticky) {

            headerTop = announcementHeight + spacing;

        } else {

            if (
                scrollTop < announcementHeight &&
                announcementHeight > 0
            ) {
                headerTop = announcementHeight + spacing;
            } else {
                headerTop = spacing;
            }
        }

        headerTop += productBarHeight - (isDesktop ? 18 : 10);


        if (isSticky) {
            $header.css({
                marginTop: 0,
                top: headerTop + 'px'
            });

        } else {

            $header.css({
                marginTop: headerTop + 'px',
                top: 0
            });
        }


        /*
         * NAVIGATION POSITION
         */

        if (isDesktop) {

            let navTop = 88;

            if (isSticky) {

                navTop += announcementHeight;

            } else if (
                scrollTop < announcementHeight &&
                announcementHeight > 0
            ) {

                navTop += announcementHeight;
            }

            navTop += productBarHeight - 19;

            $nav.css({
                top: navTop + 'px',
                maxHeight: `calc(100dvh - ${navTop}px)`
            });

        } else {

            $nav.css({
                top: 'unset',
                maxHeight: 'unset'
            });
        }
    }


    updateMTW5Header();


    $(window).on(
        'scroll.mtw5PdpBar',
        updateMTW5Header
    );

    $(window).on(
        'resize.mtw5PdpBar',
        updateMTW5Header
    );
});


if ($('.custom-video-slider').length) {
    var customVideoSwiper = new Swiper('.custom-video-slider', {
        speed: 1500,
        pagination: {
            el: '.custom-video-slider .swiper-pagination',
            clickable: true
        }
    });
}


if ($('.custom-img-slider').length) {
    var customImgSwiper = new Swiper('.custom-img-slider', {
        speed: 1500,
        pagination: {
            el: '.custom-img-slider .swiper-pagination',
            clickable: true
        }
    });
}